import React from 'react';
import IG from '../images/logo/instagram.svg';
import linkedin from '../images/logo/linkedin.svg';

const Footer = () => {
  return (
    <footer className='w-full h-fit sticky flex flex-col justify-center items-center bg-[#151b27] bottom-0 gap-8 py-10'>
        <h1 className='text-white text-xl font-poppins font-normal'>© Valentino Triadi</h1>
        <div className='flex flex-row justify-center items-center'>
            <div className='flex flex-row justify-center items-center gap-5'>
                <a href="https://www.linkedin.com/in/valentino-triadi/" target="_blank" rel="noreferrer"><img className='opacity-50 hover:opacity-100' src={linkedin} width={50} alt="linkedin" /></a>
                <a href="https://www.instagram.com/valentinotriadi/" target="_blank" rel="noreferrer"><img className='opacity-50 hover:opacity-100' src={IG} width={50} alt="IG" /></a>
            </div>
        </div>
    </footer>
  );
};

export default Footer;
